document.addEventListener("DOMContentLoaded", function () {
  // Loop over each top-level menu item
  const topMenuItems = document.querySelectorAll(".mega-menu-nav-title");

  topMenuItems.forEach((item) => {
    const container = item.querySelector(".mega-menu-container");
    if (!container) return;

    const imgContainer = container.querySelector(".mega-menu-collection-img");

    // Include the top-level nav link itself
    const menuLinks = item.querySelectorAll(
      ".mega-menu-nav, .mega-submenu-link, .mega-sub-submenu-link"
    );

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const imgUrl = link.getAttribute("data-image");
        if (imgUrl) {
          imgContainer.innerHTML = `
            <img src="${imgUrl}" 
                 alt="${link.textContent.trim()}" 
                 style="width:100%; height:290px; border-radius:4px; object-fit:cover;">
          `;
        } else {
          imgContainer.innerHTML = ""; // clear if no image
        }
      });
    });

    // Optional: clear image when leaving the whole container
    item.addEventListener("mouseleave", () => {
      imgContainer.innerHTML = "";
    });
  });
});
